import { createFileRoute } from '@tanstack/react-router'
import { AccessSection } from '@/routes/(private)/profile/-components/access-section'
import { PersonalDataSection } from '@/routes/(private)/profile/-components/personal-data-section'
import { ProfileHeader } from '@/routes/(private)/profile/-components/profile-header'

export const Route = createFileRoute('/(private)/profile/personal')({
	staticData: {
		breadcrumb: 'profile:nav.personal'
	},
	component: ProfilePersonalPage
})

function ProfilePersonalPage() {
	return (
		<div className='flex w-full flex-col gap-8 p-8'>
			<ProfileHeader />
			<PersonalDataSection />
			<AccessSection />
		</div>
	)
}
